module.exports = __webpack_public_path__ + "img/icon-bell.7e56468d.svg";